import React from "react";
import { Loading } from "@src/common/components/Loading/Loading";
import { useOrderInvoiceStatus } from "./hooks/useOrderInvoiceStatus";
import { formatInvoiceStatus } from "./utils/formatInvoiceStatus";
import { formatInvoicePaymentStatus } from "./utils/formatInvoicePaymentStatus";

interface Props {
  orderId: string;
}

export function InvoiceStatusPanel({ orderId }: Props) {
  const { invoiceNumber, invoiceStatus, invoicePaymentStatus, loading, called } =
    useOrderInvoiceStatus(orderId);

  const hasInvoice =
    invoiceNumber != null ||
    invoiceStatus != null ||
    invoicePaymentStatus != null;

  return (
    <div className="my-4">
      <span className="font-semibold">Invoice</span>
      <Loading loading={loading}>
        <div className="flex flex-col gap-2 rounded-md border dark:border-gray-700 p-1 py-3 text-gray-600 dark:text-gray-300 min-h-[2.5rem]">
          {called && !loading && !hasInvoice && (
            <div className="text-sm pl-4 pr-4 text-slate-400 dark:text-gray-400 italic">
              No invoice associated with this order.
            </div>
          )}
          {invoiceNumber && (
            <div className="text-sm flex justify-between w-full pl-4 pr-4">
              <span className="flex-1 text-slate-400 dark:text-gray-400">
                Invoice Number
              </span>
              <span className="flex-1 font-bold">{invoiceNumber}</span>
            </div>
          )}
          {invoiceStatus && (
            <div className="text-sm flex justify-between w-full pl-4 pr-4">
              <span className="flex-1 text-slate-400 dark:text-gray-400">
                Invoice Status
              </span>
              <span className="flex-1 font-bold">
                {formatInvoiceStatus(invoiceStatus)}
              </span>
            </div>
          )}
          {invoicePaymentStatus && (
            <div className="text-sm flex justify-between w-full pl-4 pr-4">
              <span className="flex-1 text-slate-400 dark:text-gray-400">
                Payment Status
              </span>
              <span className="flex-1 font-bold">
                {formatInvoicePaymentStatus(invoicePaymentStatus)}
              </span>
            </div>
          )}
        </div>
      </Loading>
    </div>
  );
}
